module.exports = __webpack_public_path__ + "static/img/logo.6759480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 119
// module chunks = 1